angular.module('lf.common')

.controller('SubscriptionCtrl', function ($scope, $injector) {
  var client = lf.data.xhr.client;
  var isDesktop = client.isDesktop || client.isLFC;
  var popupsService = $injector.get(isDesktop ? 'popupsService' : '$popups');

  $scope.showProcessingPopup = function () {
    popupsService.show('processing');
  }
  
  $scope.hideProcessingPopup = function () {
    popupsService.hide('processing');
  }
});
